/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2016, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery',
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'text!./templates/FilterWidget.html',
	'../../../lib/@waca/dashboard-common/dist/utils/EventChainLocal',
	'../../util/KeyCodes'
], function ($, BaseView, template, EventChainLocal, KeyCodes) {
	'use strict';


	var FilterWidgetCommonView = null;
	FilterWidgetCommonView = BaseView.extend({

		className: 'filterWidgetContent',

		events: {},

		templateString: template,

		init: function (params) {
			FilterWidgetCommonView.inherited('init', this, arguments);
			this.$parentEl = params.$parentEl;
			this.$parentEl.append(this.$el);
			this.$el.on('keyup keydown', 'button, input, .ba-common-list', this._keyHandler.bind(this));
			this.$el.on('clicktap.preventToolbar', 'button, input, .ba-common-list', { allowPropagationDefaultAction: true }, this._preventDefaultContextBar.bind(this));
		},

		render: function() {
			this.$el.empty();
			this.$el.html(this.dotTemplate());
			return Promise.resolve();
		},

		renderInFilterItemView: function(viewModel) {
			return this.render(viewModel)
				.then(Promise.resolve.bind(Promise, { mountNode: this.getWidgetMountNode() }));
		},

		updateMenuState: function(viewModel) {
			return this.menu.updateMenuItems(viewModel.menuItems);
		},

		getWidgetMountNode: function () {
			return this.$('.filter-container');
		},

		addClass: function(clsName) {
			this.$parentEl.addClass(clsName);
		},

		setParentHeight: function(height){
			this.$parentEl.css('height',height);
		},

		remove: function(){
			this.$el.off('clicktap.preventToolbar');
			this.$parentEl = null;
			FilterWidgetCommonView.inherited('remove', this);
		},

		_preventDefaultContextBar: function(event) {
			var eventChainLocal = new EventChainLocal(event);
			eventChainLocal.setProperty('preventDefaultContextBar', true);
		},

		_isArrowKey: function(keyCode) {
			return keyCode == KeyCodes.KEY_LEFT ||
					keyCode == KeyCodes.KEY_UP ||
					keyCode == KeyCodes.KEY_RIGHT ||
					keyCode == KeyCodes.KEY_DOWN;
		},

		_keyHandler: function(event) {
			this._preventDefaultContextBar(event);
			var eventChainLocal = new EventChainLocal(event);

			if((event.keyCode == KeyCodes.KEY_SPACE || event.keyCode == KeyCodes.KEY_ENTER)) {
				eventChainLocal.setProperty('preventWidgetSelection', true);
			} else if(this._isArrowKey(event.keyCode)) {
				eventChainLocal.setProperty('preventMoveAction', true);
			}
		}
	});

	return FilterWidgetCommonView;
});
